import { Button, Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import LoadingScreen from "src/components/LoadingScreen";
import useSettings from "src/hooks/useSettings";
import { PATH_DASHBOARD } from "src/routes/paths";
import CacheSessionTable from "./CacheSessionTable";
import { getCacheSessDataApi } from "src/Api/Services/SystemConfiguration";
import UpdateCacheSession from "./UpdateCacheSession";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";

const CacheSession = () => {
  const { themeStretch } = useSettings();
  const [cacheSessData, setCacheSessData] = useState([]);
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState("");
  const [loading, setloading] = useState(true);
  const fetchData = async () => {
    try {
      const { data } = await getCacheSessDataApi();
      let newRes = data.data.length > 0 ? data.data : [];
      setCacheSessData(newRes || []);
    } catch (error) {
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Container maxWidth={themeStretch ? false : "xxxl"} spacing={1}>
      <HeaderBreadcrumbs
        heading="Cache Session Data"
        links={[
          { name: "Dashboard", href: PATH_DASHBOARD.root },
          {
            name: "Add Cache Session",
            href: PATH_DASHBOARD.systemConfig.cacheSession,
          },
        ]}
      />
      <div className="text-right">
        {/* <Button
          //   onClick={() => {
          //     setShow(true);
          //     setEditData("");
          //   }}
          variant="outlined"
        >
          Add Session <AddIcon />
        </Button> */}
        <CacheSessionTable
          data={cacheSessData}
          editBtnClick={(item) => setEditData(item)}
        />
      </div>
      <CustomModalComp
        show={editData ? true : false}
        onHide={() => setEditData("")}
        title="Update Cache Session"
        backdrop={true}
      >
        <UpdateCacheSession
          data={editData}
          fetchData={() => {
            fetchData();
            setEditData("");
          }}
        />
      </CustomModalComp>
    </Container>
  );
};

export default CacheSession;
